import React from 'react';
import { DefaultLegendContent, DefaultLegendContentProps, DefaultTooltipContentProps } from 'recharts';
import { Box, Typography } from '@mui/material';
import { Payload } from 'recharts/types/component/DefaultLegendContent';

export const CustomizedYAxisLabel = ({
  viewBox,
  label,
  color,
}: {
  viewBox?: { x: number; y: number; height: number };
  label?: string;
  color?: string;
}) => {
  if (!viewBox) {
    return null;
  }

  const { x, y, height } = viewBox;
  const cx = x + 25;
  const cy = y + height / 2;

  return (
    <text
      x={cx}
      y={cy}
      transform={`rotate(-90, ${cx}, ${cy})`}
      textAnchor="middle"
      fill={color}
      fontWeight={700}
      fontSize="12"
    >
      {label}
    </text>
  );
};

export const CustomLegend = (props: DefaultLegendContentProps) => {
  const extendedPayload = [
    {
      value: 'Reported (%)',
      type: 'line',
      color: 'var(--mui-palette-text-secondary)',
      id: 'dot-line',
    },
    {
      value: 'Assignment Range',
      type: 'rect',
      color: 'var(--mui-palette-text-secondary)',
      id: 'ref-line',
    },
  ];

  return <DefaultLegendContent {...(props as any)} payload={extendedPayload as unknown as Payload[]} />;
};

export const CustomTooltip = (props: DefaultTooltipContentProps<string, string>) => {
  const { payload } = props;

  if (payload && payload.length) {
    let rangeMin: number | null = null;
    let rangeDelta: number | null = null;
    const week = payload[0]?.payload?.week ?? '–';

    return (
      <Box bgcolor="background.paper" border={1} borderColor="border.medium" p={1}>
        <Typography variant="subtitle2">Week: {week}</Typography>

        {payload.map((entry, i) => {
          if (entry.name === 'rangeMin') {
            rangeMin = Number(entry.value);
            return null;
          }

          if (entry.name === 'rangeDelta') {
            rangeDelta = Number(entry.value);
            return null;
          }

          return (
            // eslint-disable-next-line react/no-array-index-key
            <Box key={i} display="flex" alignItems="center" gap={1}>
              <Box sx={{ width: 10, height: 10, background: entry.color }} />
              <Typography variant="body2">{`Reported: ${entry.value}%`}</Typography>
            </Box>
          );
        })}

        {rangeMin !== null && rangeDelta !== null && (
          <Box display="flex" alignItems="center" gap={1} mt={0.5}>
            <Box width={10} height={10} bgcolor="border.default" />

            <Typography variant="body2">
              Range: {rangeMin}% - {rangeMin + rangeDelta}%
            </Typography>
          </Box>
        )}
      </Box>
    );
  }

  return null;
};
